import { render, staticRenderFns } from "./AuditLogTable.vue?vue&type=template&id=932a1672&scoped=true&"
import script from "./AuditLogTable.vue?vue&type=script&lang=js&"
export * from "./AuditLogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932a1672",
  null
  
)

export default component.exports